export const descriptionIconStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  color: 'text.secondary',
  cursor: 'help',
};
